
import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';

export const REQUEST_LOGOS = 'REQUEST_LOGOS';
export const RECEIVE_LOGOS = 'RECEIVE_LOGOS';
export const FINISH_LOGOS_FETCHING = 'FINISH_LOGOS_FETCHING';
export const RECEIVE_ERROR = 'RECEIVE_ERROR';

const url = `${config.apiBasePath}/logo`;

const requestLogosAction = {
  type: REQUEST_LOGOS,
};

const finishLogosFetchingAction = {
  type: FINISH_LOGOS_FETCHING,
};

export function receiveLogos(logos) {
  return {
    type: RECEIVE_LOGOS,
    logos,
  };
}

export function receiveError(json) {
  return {
    type: RECEIVE_ERROR,
    error: json.error,
  };
}

export function fetchLogos() {
  return (dispatch, getState, { network }) => {
    dispatch(requestLogosAction);

    return network.get(url)
      .then((logos) => {
        dispatch(receiveLogos(logos));
        dispatch(finishLogosFetchingAction);
      })
      .catch(err => {
        dispatch(receiveError(err.data || UNKNOWN_ERROR));
      });
  };
}
